export default "__VITE_ASSET__DjBwvYVw__"